module.exports = __webpack_public_path__ + "static/media/direction.347a4632.svg";